import { BuildingIdAction, SET_BUILDINGID } from '../type';

export const setBuildingId = (buildingId: string): BuildingIdAction => {
    localStorage.setItem('BuildingId', buildingId);
    return {
        type: SET_BUILDINGID,
        payload: buildingId
    };
};
